
import { useState } from 'react';

import classes from './PushTimeout.module.scss';
import signpost from '../../../../../assets/img/signpost.svg';
import PushBottom from '../Bottom/PushBottom';
import Ajax from '../../../../../Handler/Ajax';
import Toast from '../../../../Form/Toast';


declare var _loginMethodSmsOtpUrl: any;
declare function Translate(key: string): string;

const PushTimeout = (props) => {

    const [serverMessage,setServerMessage] = useState('');
    
    const backToMainClick = () => {       
        Ajax.ResetUserStatus()
            .then(() => {                                  
                window.location = _loginMethodSmsOtpUrl;
            })
            .catch((error) => {                                  
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));          
            });
    };

    const backToMainPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            backToMainClick();
        }
    };

    const onResetErrorHandler = (error:string) => {
        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
    };

    return(
       <div className={classes.main}>
            {serverMessage.length > 0 && (
                <Toast message={serverMessage} />
            )}
            
            <img src={signpost} className={classes.img} alt="" />
            <div className={classes.title}>
                {props.step === 1 &&
                    <span>{Translate('N_General_unibeam_61')}</span> 
                }
                {props.step === 2 &&
                    <span>{Translate('N_General_unibeam_63')}</span>  
                }              
            </div>
            <div className={classes.desc}>
                {props.step === 1 &&
                    <span>{Translate('N_General_unibeam_62')}</span>  
                }
                {props.step === 2 &&
                    <span>{Translate('N_General_unibeam_64')}</span>  
                }            
            </div>
            <div className={classes.subMain}>
                <div className={classes.confirm}>
                    <span>{Translate('N_General_unibeam_56')}</span>&nbsp;
                    <span className={classes.bold}>{Translate('N_General_unibeam_57')}</span>&nbsp;
                    <span>{Translate('N_General_unibeam_58')}</span>&nbsp;                    
                    <span>{Translate('N_General_unibeam_59')}</span>&nbsp;
                </div>
                <div className={classes.buttonContainer}>
                    <button
                        id='backToLoginBtn' 
                        className={classes.button} 
                        onClick={backToMainClick}
                        onKeyPress={backToMainPress}
                    >{Translate('N_General_unibeam_60')}</button>
                </div>
                 <hr />               
            </div>

            <PushBottom onResetError={onResetErrorHandler}/>
        </div>
    );
}
export default PushTimeout;